import axios from 'axios'

import {URL_PREFIX} from '../config'

// export const getAllArtwork = (order, search, artistId) => {
//    const params = {
//      page: 1,
//      page_size: 2147483647,
//   };
//   if (order) {
//     params.ordering = order;
//   }
//   if (search) {
//     params.search = search;
//   }
//   return axios.get(URL_PREFIX + "/artworks", {
//     params
//   });
// };

function getFilterValue(filter) {
    if (!filter) return null
    if (filter.value) {
        return filter.value.toString().trim()
    } else {
        return filter.toString().trim()
    }
}

export const getArtwork = (
    page,
    pageSize,
    order,
    search,
    artistId,
    filters = {},
    cancelToken = null
) => {
    const params = {
        page,
        page_size: pageSize
    }
    if (order) {
        params.ordering = order
    }
    if (search) {
        params.search = search
    }
    if (!filters) filters = {}

    if (filters.startDateFilter) {
        params.startDateFilter = getFilterValue(filters.startDateFilter)
    }
    if (filters.endDateFilter) {
        params.endDateFilter = getFilterValue(filters.endDateFilter)
    }
    if (filters.minPriceFilter) {
        params.minPriceFilter = getFilterValue(filters.minPriceFilter)
    }
    if (filters.maxPriceFilter) {
        params.maxPriceFilter = getFilterValue(filters.maxPriceFilter)
    }
    if (filters.minSizeWFilter) {
        params.minSizeWFilter = getFilterValue(filters.minSizeWFilter)
    }
    if (filters.minSizeHFilter) {
        params.maxSizeFilter = getFilterValue(filters.minSizeHFilter)
    }
    if (filters.maxSizeWFilter) {
        params.maxSizeWFilter = getFilterValue(filters.maxSizeWFilter)
    }
    if (filters.maxSizeHFilter) {
        params.maxSizeHFilter = getFilterValue(filters.maxSizeHFilter)
    }
    if (filters.collectionFilter) {
        params.collectionFilter = getFilterValue(filters.collectionFilter)
    }
    if (filters.exhibitionFilter) {
        params.exhibitionFilter = getFilterValue(filters.exhibitionFilter)
    }
    if (filters.mediumFilter) {
        params.mediumFilter = getFilterValue(filters.mediumFilter)
    }
    if (filters.styleFilter) {
        params.styleFilter = getFilterValue(filters.styleFilter)
    }
    if (filters.subjectFilter) {
        params.subjectFilter = getFilterValue(filters.subjectFilter)
    }
    if (filters.usedTypeFilter) {
        params.usedTypeFilter = getFilterValue(filters.usedTypeFilter)
    }
    if (filters.colorFilter) {
        params.colorFilter = getFilterValue(filters.colorFilter)
    }
    if (filters.inStockFilter) {
        params.inStockFilter = getFilterValue(filters.inStockFilter)
    }

    return axios.get(URL_PREFIX + '/artworks/', {
        params: params,
        cancelToken: cancelToken?.token
    })
}

export const getArtworkAdmin = (
    page,
    pageSize,
    order,
    search,
    artistId,
    filters = {},
    cancelToken = null
) => {
    const params = {
        page,
        page_size: pageSize
    }
    if (order) {
        params.ordering = order
    }
    if (search) {
        params.search = search
    }
    if (artistId) {
        params.artist_id = artistId
    }
    if (!filters) filters = {}

    if (filters.startDateFilter) {
        params.startDateFilter = getFilterValue(filters.startDateFilter)
    }
    if (filters.endDateFilter) {
        params.endDateFilter = getFilterValue(filters.endDateFilter)
    }
    if (filters.minPriceFilter) {
        params.minPriceFilter = getFilterValue(filters.minPriceFilter)
    }
    if (filters.maxPriceFilter) {
        params.maxPriceFilter = getFilterValue(filters.maxPriceFilter)
    }
    if (filters.minSizeWFilter) {
        params.minSizeWFilter = getFilterValue(filters.minSizeWFilter)
    }
    if (filters.minSizeHFilter) {
        params.maxSizeFilter = getFilterValue(filters.minSizeHFilter)
    }
    if (filters.maxSizeWFilter) {
        params.maxSizeWFilter = getFilterValue(filters.maxSizeWFilter)
    }
    if (filters.maxSizeHFilter) {
        params.maxSizeHFilter = getFilterValue(filters.maxSizeHFilter)
    }
    if (filters.collectionFilter) {
        params.collectionFilter = getFilterValue(filters.collectionFilter)
    }
    if (filters.exhibitionFilter) {
        params.exhibitionFilter = getFilterValue(filters.exhibitionFilter)
    }
    if (filters.mediumFilter) {
        params.mediumFilter = getFilterValue(filters.mediumFilter)
    }
    if (filters.styleFilter) {
        params.styleFilter = getFilterValue(filters.styleFilter)
    }
    if (filters.subjectFilter) {
        params.subjectFilter = getFilterValue(filters.subjectFilter)
    }
    if (filters.usedTypeFilter) {
        params.usedTypeFilter = getFilterValue(filters.usedTypeFilter)
    }
    if (filters.colorFilter) {
        params.colorFilter = getFilterValue(filters.colorFilter)
    }
    if (filters.inStockFilter) {
        params.inStockFilter = getFilterValue(filters.inStockFilter)
    }

    return axios.get(URL_PREFIX + '/artworks-admin/', {
        params: params,
        cancelToken: cancelToken?.token
    })
}

export const getArtworkById = (id, cancelToken = null) => {
    return axios.get(URL_PREFIX + '/artworks/' + id + '/', {
        cancelToken: cancelToken?.token
    })
}

export const postArtwork = (param) => {
    return axios.post(URL_PREFIX + '/artworks/', {
        ...param,
        label: [], // temp
        materials: [],
        medium_type: [],
        material_type: [],
        size_type: [],
        sell_type: [],
        price_type: [],
        style_type: [],
        extra_info: [],
        color_info: [],
        content_info: []
    })
}

export const postArtworkAdmin = (param) => {
    return axios.post(URL_PREFIX + '/artworks-admin/', {
        ...param,
        label: [], // temp
        materials: [],
        medium_type: [],
        material_type: [],
        size_type: [],
        sell_type: [],
        price_type: [],
        style_type: [],
        extra_info: [],
        color_info: [],
        content_info: []
    })
}

export const putArtwork = (id, param) => {
    return axios.put(URL_PREFIX + '/artworks/' + id + '/', {
        id,
        ...param,
        label: [], // temp
        materials: [],
        material_type: [],
        size_type: [],
        sell_type: [],
        price_type: [],
        style_type: [],
        extra_info: [],
        color_info: [],
        content_info: []
    })
}

export const patchArtwork = (id, param) => {
    return axios.patch(URL_PREFIX + '/artworks/' + id + '/', {
        ...param
    })
}

export const bulkPatchArtwork = (data, cancelToken) => {
    return axios.patch('/bulk/artworks', data, {
        cancelToken: cancelToken?.token
    })
}

export const deleteArtwork = (id) => {
    return axios.delete(URL_PREFIX + '/artworks/' + id + '/')
}
